import { render, staticRenderFns } from "./PagosSIIGEM.vue?vue&type=template&id=2a06961b&"
import script from "./PagosSIIGEM.vue?vue&type=script&lang=js&"
export * from "./PagosSIIGEM.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports